import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

/**
 * Reusable bottom-of-page conversion CTA. Renders a glassy panel with
 * a headline and two buttons.
 */
export default function PageCTA({
  title = "Ready to grow your business with APEX?",
  subtitle = "Get a free strategy call — no hard sell, just clear next steps.",
  primary = { label: "Start a Project", to: "/contact" },
  secondary = { label: "View Services", to: "/services" },
}) {
  return (
    <section className="section-pad relative">
      <div className="container-apex">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative rounded-[32px] overflow-hidden border border-white/10 bg-white/[0.03] backdrop-blur-xl p-8 md:p-14 text-center"
          data-testid="page-cta"
        >
          <div className="absolute inset-0 -z-10 pointer-events-none">
            <div className="absolute top-[-20%] left-[-10%] w-[440px] h-[440px] rounded-full bg-apex-blue/35 blur-[140px]" />
            <div className="absolute bottom-[-20%] right-[-10%] w-[440px] h-[440px] rounded-full bg-apex-orange/30 blur-[140px]" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-extrabold leading-[1.05]">
            {title}
          </h2>
          <p className="mt-4 text-white/75 max-w-2xl mx-auto text-base md:text-lg leading-relaxed" data-align-preserve>
            {subtitle}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to={primary.to} className="btn-primary" data-testid="pagecta-primary">
              {primary.label} <ArrowUpRight className="w-4 h-4" strokeWidth={2.2} />
            </Link>
            {secondary && (
              <Link to={secondary.to} className="btn-ghost" data-testid="pagecta-secondary">
                {secondary.label}
              </Link>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
